const COMMON_CONSTANTS = {
  DESKTOP_WIDTH_BREAKPOINT: 1124,
};

export default COMMON_CONSTANTS;
